'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

class LinksService {
  constructor() {
    this.listeners = new Set();
    this.handleLinkClick = (event) => {
      const target = this.getTarget(event);
      if (event.defaultPrevented) {
        return;
      }
      if (target && target.getAttribute("data-ignore")) {
        return;
      }
      if (target && target.tagName === "A" && !this.isExternal(target)) {
        event.preventDefault();
        this.listeners.forEach((listener) => {
          try {
            listener(target.getAttribute("href"));
          } catch (e) {
            console.group();
            console.error("Error in link handler for", target);
            console.error(e);
            console.groupEnd();
          }
        });
      }
    };
  }
  registerLinkHandler(handler) {
    this.attachClickEvent();
    this.listeners.add(handler);
    return () => {
      this.listeners.delete(handler);
      if (this.listeners.size === 0) {
        this.deregisterLinkHandler();
      }
    };
  }
  getTarget(event) {
    if (!event.composedPath) {
      return event.target;
    } else {
      return event.composedPath().find((el) => el.tagName === "A");
    }
  }
  attachClickEvent() {
    if (this.listeners.size > 0) {
      return;
    }
    document.body.addEventListener("click", this.handleLinkClick);
  }
  deregisterLinkHandler() {
    document.body.removeEventListener("click", this.handleLinkClick);
  }
  isExternal(link) {
    const href = link.getAttribute("href");
    return !href || /nofollow|noopener/.test(link.getAttribute("rel")) || /blank/.test(link.getAttribute("target")) || /^(https?:|mailto:)/.test(href);
  }
}
const links = new LinksService();

exports.LinksService = LinksService;
exports.links = links;
